var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.001,
    height: 248.786,
    viewBox: "0 0 300.001 248.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5e5e5e",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#898989",
    stopOpacity: 0.459
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#999",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a",
    stopOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b6013c34221665586d1b082a0615f6ca",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_560",
    "data-name": "Pfad 560",
    d: "M58.33,321.38v4.44a3.541,3.541,0,0,0,3.531,3.551H298.75a3.536,3.536,0,0,0,3.526-3.551v-4.44Z",
    transform: "translate(-30.777 -161.653)",
    fill: "#1c1e20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_561",
    "data-name": "Pfad 561",
    d: "M302.479,407.875l-23.854-68.566a8.116,8.116,0,0,0-7.667-5.449H248.827v.609H57.364v-.609H35.3a8.121,8.121,0,0,0-7.682,5.494L4.142,407.91a5.584,5.584,0,0,0,5.3,7.382H297.2a5.584,5.584,0,0,0,5.274-7.417Z",
    transform: "translate(-3.505 -167.9)",
    fill: "#e1e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_562",
    "data-name": "Pfad 562",
    d: "M302.9,484.143l-.759-2.093a5.584,5.584,0,0,1-5.274,7.417H9.106a5.579,5.579,0,0,1-5.579-5.554l-.09.27a5.07,5.07,0,0,0,4.815,6.678H298.1a5.075,5.075,0,0,0,4.8-6.718Z",
    transform: "translate(-3.17 -242.075)",
    fill: "#acadaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_563",
    "data-name": "Pfad 563",
    d: "M245.775,496.918h57.043a.5.5,0,0,1,.255.08v-1a1,1,0,0,0-1-1H246.549a1,1,0,0,0-1,1v1A.5.5,0,0,1,245.775,496.918Z",
    transform: "translate(-124.488 -248.557)",
    fill: "#898a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_564",
    "data-name": "Pfad 564",
    d: "M301.492,460.584H183.575a1.528,1.528,0,0,1-1.5-1.728l4.036-30.2a1,1,0,0,1,1-.884H297.667a1,1,0,0,1,1,.874L303,458.851a1.528,1.528,0,0,1-1.508,1.733Z",
    transform: "translate(-92.711 -214.906)",
    fill: "#cccdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_565",
    "data-name": "Pfad 565",
    d: "M299.134,338.516H104.55l1.084-3.626H298.14Z",
    transform: "translate(-52.329 -167.626)",
    fill: "#cccdcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_566",
    "data-name": "Pfad 566",
    d: "M299.331,384.511H23.25l13.96-40.6H285.376Z",
    transform: "translate(-11.635 -172.141)",
    fill: "#e4e6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_567",
    "data-name": "Pfad 567",
    d: "M78.625,349.927H56.344a.769.769,0,0,1-.739-1l.235-.8a1.928,1.928,0,0,1,1.848-1.384H79.379a.9.9,0,0,1,.879,1.129l-.25,1a1.428,1.428,0,0,1-1.383,1.059Z",
    transform: "translate(-29.395 -174.347)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_568",
    "data-name": "Pfad 568",
    d: "M65.891,360.513H51.337a.464.464,0,0,1-.5-.6l1.828-4.685a.8.8,0,0,1,.764-.5H67.564a.929.929,0,0,1,1,1.159l-1.2,3.646A1.5,1.5,0,0,1,65.891,360.513Z",
    transform: "translate(-27.015 -178.341)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    d: "M70.449,373.948H46.974a.814.814,0,0,1-.764-1.094l1.678-4.52a1,1,0,0,1,.954-.664h23.3a.7.7,0,0,1,.679.889l-1.2,4.5a1.219,1.219,0,0,1-1.174.894Z",
    transform: "translate(-24.686 -184.823)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    d: "M70.427,388.193H41.868a.629.629,0,0,1-.614-.839l1.853-4.86a1,1,0,0,1,.924-.614H72.275A.724.724,0,0,1,73,382.8l-1.423,4.56A1.209,1.209,0,0,1,70.427,388.193Z",
    transform: "translate(-22.212 -191.935)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_571",
    "data-name": "Pfad 571",
    d: "M74.926,402.707h-38.3a.714.714,0,0,1-.659-.924l1.713-4.91a1.933,1.933,0,0,1,1.828-1.294h37a1,1,0,0,1,1,1.224l-1,4.635A1.633,1.633,0,0,1,74.926,402.707Z",
    transform: "translate(-19.568 -198.793)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_572",
    "data-name": "Pfad 572",
    d: "M47.119,418.437H31.9a1,1,0,0,1-.949-1.374l1.938-5.114a1,1,0,0,1,.949-.659H49.007a.909.909,0,0,1,.874,1.164l-1.448,4.995A1.364,1.364,0,0,1,47.119,418.437Z",
    transform: "translate(-17.034 -206.657)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_573",
    "data-name": "Pfad 573",
    d: "M84.714,418.437H69.491a1,1,0,0,1-.954-1.374l1.838-5.374a.619.619,0,0,1,.579-.4H86.6a.914.914,0,0,1,.879,1.164l-1.453,4.995a1.359,1.359,0,0,1-1.309.989Z",
    transform: "translate(-35.849 -206.657)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_574",
    "data-name": "Pfad 574",
    d: "M122.568,418.427H107.349a.819.819,0,0,1-.8-1l1.1-5.079a1.364,1.364,0,0,1,1.334-1.079h15.263a.709.709,0,0,1,.7.824l-.794,4.955A1.623,1.623,0,0,1,122.568,418.427Z",
    transform: "translate(-54.903 -206.647)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_575",
    "data-name": "Pfad 575",
    d: "M165.262,418.437H144.974a1,1,0,0,1-1-1.219l.939-4.7a1.523,1.523,0,0,1,1.5-1.224h20a.864.864,0,0,1,.849,1l-.969,5.294A1,1,0,0,1,165.262,418.437Z",
    transform: "translate(-73.634 -206.657)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_576",
    "data-name": "Pfad 576",
    d: "M282.572,418.437H191.985a1,1,0,0,1-1-1.164l.774-4.91a1.269,1.269,0,0,1,1.254-1.074h89.069a1.653,1.653,0,0,1,1.653,1.6l.135,4.205a1.3,1.3,0,0,1-1.3,1.344Z",
    transform: "translate(-97.17 -206.657)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_577",
    "data-name": "Pfad 577",
    d: "M400.108,418.437H379.83a1.159,1.159,0,0,1-1.154-1.064l-.41-5.169a.844.844,0,0,1,.844-.914h20.123a1.3,1.3,0,0,1,1.294,1.149l.569,4.915a1,1,0,0,1-.989,1.084Z",
    transform: "translate(-190.917 -206.657)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_578",
    "data-name": "Pfad 578",
    d: "M393.969,402.682H378.191a1.034,1.034,0,0,1-.894-1.064l-.31-5.174a.784.784,0,0,1,.654-.914h15.653a1.139,1.139,0,0,1,1,1.149l.445,4.92a.914.914,0,0,1-.769,1.084Z",
    transform: "translate(-190.272 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_579",
    "data-name": "Pfad 579",
    d: "M410.373,388.178H395.09a.969.969,0,0,1-.869-1l-.31-4.8a.739.739,0,0,1,.634-.849h14.889a1.079,1.079,0,0,1,1,1.084l.689,4.56a.854.854,0,0,1-.749,1Z",
    transform: "translate(-198.744 -191.761)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_580",
    "data-name": "Pfad 580",
    d: "M374.273,388.178H358.915a.969.969,0,0,1-.869-1l-.315-4.8a.739.739,0,0,1,.639-.849H373.6a1.079,1.079,0,0,1,.974,1.069l.43,4.56a.849.849,0,0,1-.729,1.019Z",
    transform: "translate(-180.635 -191.761)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_581",
    "data-name": "Pfad 581",
    d: "M430.5,402.7H415.826a1.648,1.648,0,0,1-1.613-1.389l-.8-4.75a.859.859,0,0,1,.834-1H429.3a1.179,1.179,0,0,1,1.144.939l1.069,4.93a1.044,1.044,0,0,1-1,1.269Z",
    transform: "translate(-208.503 -198.783)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_582",
    "data-name": "Pfad 582",
    d: "M446.071,388.193H431.7a1.593,1.593,0,0,1-1.578-1.289l-.784-4.405a.809.809,0,0,1,.814-.939h14.734a1.134,1.134,0,0,1,1.119.869L447.055,387a1,1,0,0,1-.984,1.189Z",
    transform: "translate(-216.477 -191.775)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_583",
    "data-name": "Pfad 583",
    d: "M442.446,418.452H427.527a1.663,1.663,0,0,1-1.638-1.389l-.819-4.745a.864.864,0,0,1,.849-1h15.318a1.194,1.194,0,0,1,1.164.939l1.084,4.93a1.049,1.049,0,0,1-1.039,1.264Z",
    transform: "translate(-214.34 -206.672)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_584",
    "data-name": "Pfad 584",
    d: "M480.1,418.422H464.82a1.424,1.424,0,0,1-1.384-1.1l-1.174-5.189a.714.714,0,0,1,.694-.869h15.363a1.423,1.423,0,0,1,1.374,1.059l1.294,4.94a.919.919,0,0,1-.884,1.164Z",
    transform: "translate(-232.954 -206.642)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_585",
    "data-name": "Pfad 585",
    d: "M467.024,402.682H451.845a1.413,1.413,0,0,1-1.378-1.109L449.3,396.4a.714.714,0,0,1,.694-.869h15.263a1.413,1.413,0,0,1,1.364,1.059l1.284,4.945a.919.919,0,0,1-.884,1.149Z",
    transform: "translate(-226.467 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_586",
    "data-name": "Pfad 586",
    d: "M482.121,388.218H467.352a1.354,1.354,0,0,1-1.334-1l-1.134-4.8a.669.669,0,0,1,.674-.809h14.859a1.358,1.358,0,0,1,1.324,1l1.249,4.59a.854.854,0,0,1-.869,1.019Z",
    transform: "translate(-234.267 -191.8)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_587",
    "data-name": "Pfad 587",
    d: "M517.4,418.437H502.368a1.783,1.783,0,0,1-1.718-1.324l-1.2-4.55a1,1,0,0,1,1-1.274h14.879a1.728,1.728,0,0,1,1.663,1.269l1.308,4.72a.909.909,0,0,1-.9,1.159Z",
    transform: "translate(-251.557 -206.656)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_588",
    "data-name": "Pfad 588",
    d: "M514.936,416.244H497.375l-.245-.954h17.541Z",
    transform: "translate(-248.831 -207.87)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_589",
    "data-name": "Pfad 589",
    d: "M515.206,417.285H497.655l-.085-.295h17.556Z",
    transform: "translate(-249.051 -208.721)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_590",
    "data-name": "Pfad 590",
    d: "M554.834,418.462H540.2a2.028,2.028,0,0,1-1.928-1.409l-1.413-4.385a1,1,0,0,1,.969-1.329h14.829a1.463,1.463,0,0,1,1.393,1l1.638,4.965a.894.894,0,0,1-.849,1.159Z",
    transform: "translate(-270.27 -206.681)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_591",
    "data-name": "Pfad 591",
    d: "M135.882,402.682H120.644a1,1,0,0,1-.964-1.2l1.044-4.76a1.5,1.5,0,0,1,1.5-1.194h14.235a1.234,1.234,0,0,1,1.209,1.5l-1.029,5.07A.754.754,0,0,1,135.882,402.682Z",
    transform: "translate(-61.475 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_592",
    "data-name": "Pfad 592",
    d: "M120.84,388.19H105.6a.909.909,0,0,1-.964-1.059l1.044-4.2a1.5,1.5,0,0,1,1.5-1.054h14.235a1.134,1.134,0,0,1,1.209,1.309l-1.034,4.47A.729.729,0,0,1,120.84,388.19Z",
    transform: "translate(-53.949 -191.932)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_593",
    "data-name": "Pfad 593",
    d: "M172.087,402.682H157.1a1.134,1.134,0,0,1-1.109-1.374l1-4.66a1.419,1.419,0,0,1,1.389-1.119h14.245a1.563,1.563,0,0,1,1.548,1.783l-.584,4.036a1.553,1.553,0,0,1-1.5,1.334Z",
    transform: "translate(-79.649 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_594",
    "data-name": "Pfad 594",
    d: "M156.589,388.042h-14.4a1.044,1.044,0,0,1-1.064-1.244l1-4.22a1.349,1.349,0,0,1,1.334-1h13.715a1.443,1.443,0,0,1,1.5,1.613l-.559,3.651a1.5,1.5,0,0,1-1.518,1.2Z",
    transform: "translate(-72.207 -191.784)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_595",
    "data-name": "Pfad 595",
    d: "M209.856,402.692h-15.7a.769.769,0,0,1-.764-.864l.659-5.279a1.144,1.144,0,0,1,1.139-1h15.014a1.064,1.064,0,0,1,1.059,1.184l-.589,5.244A.8.8,0,0,1,209.856,402.692Z",
    transform: "translate(-98.379 -198.778)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_596",
    "data-name": "Pfad 596",
    d: "M193.386,388.056H177.758A.719.719,0,0,1,177,387.3l.649-4.775a1.114,1.114,0,0,1,1.139-.914h14.944a1,1,0,0,1,1.054,1.069l-.6,4.755A.779.779,0,0,1,193.386,388.056Z",
    transform: "translate(-90.175 -191.799)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_597",
    "data-name": "Pfad 597",
    d: "M246.894,402.682H231.131a.779.779,0,0,1-.774-.844l.41-4.9a1.538,1.538,0,0,1,1.528-1.4h13.8a1.748,1.748,0,0,1,1.748,1.8l-.12,4.555A.819.819,0,0,1,246.894,402.682Z",
    transform: "translate(-116.882 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_598",
    "data-name": "Pfad 598",
    d: "M229.651,388.031H214.1a.729.729,0,0,1-.764-.764l.4-4.44a1.463,1.463,0,0,1,1.5-1.269h13.61a1.653,1.653,0,0,1,1.728,1.623l-.12,4.126A.789.789,0,0,1,229.651,388.031Z",
    transform: "translate(-108.365 -191.774)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_599",
    "data-name": "Pfad 599",
    d: "M283.9,402.657H267.8a.5.5,0,0,1-.5-.534l.225-5.644a1,1,0,0,1,1-1h14.609a1.6,1.6,0,0,1,1.6,1.6v4.745a.814.814,0,0,1-.834.834Z",
    transform: "translate(-135.374 -198.743)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_600",
    "data-name": "Pfad 600",
    d: "M266.087,388.017H250.339a.5.5,0,0,1-.5-.5l.22-5.109a.964.964,0,0,1,1-.879h14.265a1.5,1.5,0,0,1,1.563,1.443v4.3a.764.764,0,0,1-.8.749Z",
    transform: "translate(-126.636 -191.759)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_601",
    "data-name": "Pfad 601",
    d: "M301.209,393.94h15.983a.629.629,0,0,1,.629.629v6.173a.35.35,0,0,1-.35.35H300.989a.569.569,0,0,1-.569-.569v-5.814a.764.764,0,0,1,.789-.769Z",
    transform: "translate(-150.37 -197.183)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_602",
    "data-name": "Pfad 602",
    d: "M283.494,380h15.583a.629.629,0,0,1,.629.629v5.494a.35.35,0,0,1-.35.35H283.3a.569.569,0,0,1-.569-.569v-5.149A.764.764,0,0,1,283.494,380Z",
    transform: "translate(-141.515 -190.206)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_603",
    "data-name": "Pfad 603",
    d: "M337.62,393.94h16.352a.579.579,0,0,1,.579.579v5.993a.559.559,0,0,1-.559.559H337.679a.44.44,0,0,1-.44-.44v-6.308a.38.38,0,0,1,.38-.385Z",
    transform: "translate(-168.8 -197.183)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_604",
    "data-name": "Pfad 604",
    d: "M318.74,380H335a.579.579,0,0,1,.579.579v5.494a.559.559,0,0,1-.559.559H318.8a.439.439,0,0,1-.44-.439V380.37a.38.38,0,0,1,.38-.37Z",
    transform: "translate(-159.349 -190.206)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_605",
    "data-name": "Pfad 605",
    d: "M400.369,374.118H385.08a.949.949,0,0,1-.864-.959l-.315-4.67a.724.724,0,0,1,.639-.829H399.43a1.069,1.069,0,0,1,.974,1.039l.684,4.44a.834.834,0,0,1-.719.979Z",
    transform: "translate(-193.735 -184.818)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_606",
    "data-name": "Pfad 606",
    d: "M364.754,374.118H349.4a.959.959,0,0,1-.874-.959l-.31-4.67a.724.724,0,0,1,.639-.829h15.234a1.069,1.069,0,0,1,1,1.039l.43,4.44a.834.834,0,0,1-.759.979Z",
    transform: "translate(-175.871 -184.818)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_607",
    "data-name": "Pfad 607",
    d: "M435.493,374.117H421.123a1.578,1.578,0,0,1-1.578-1.254l-.784-4.29a.794.794,0,0,1,.814-.914h14.734a1.134,1.134,0,0,1,1.119.849l1.049,4.455a.964.964,0,0,1-.984,1.154Z",
    transform: "translate(-211.183 -184.817)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_608",
    "data-name": "Pfad 608",
    d: "M470.7,374.117H455.913a1.354,1.354,0,0,1-1.339-1l-1.129-4.67a.654.654,0,0,1,.669-.789h14.849a1.363,1.363,0,0,1,1.324.954l1.249,4.465a.844.844,0,0,1-.839,1.039Z",
    transform: "translate(-228.542 -184.817)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_609",
    "data-name": "Pfad 609",
    d: "M505.708,374.117H491.339a1.578,1.578,0,0,1-1.578-1.254l-.769-4.29a.8.8,0,0,1,.819-.914h14.734a1.134,1.134,0,0,1,1.119.849l1.049,4.455a.964.964,0,0,1-1,1.154Z",
    transform: "translate(-246.337 -184.818)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_610",
    "data-name": "Pfad 610",
    d: "M540.874,374.118H526.11a1.353,1.353,0,0,1-1.339-1l-1.134-4.67a.664.664,0,0,1,.674-.789h14.574a1.364,1.364,0,0,1,1.324.954l1.5,4.465a.844.844,0,0,1-.834,1.039Z",
    transform: "translate(-263.677 -184.818)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_611",
    "data-name": "Pfad 611",
    d: "M115.837,374.083H100.6a.894.894,0,0,1-.969-1.029l1.049-4.086a1.5,1.5,0,0,1,1.5-1.024h14.215a1.119,1.119,0,0,1,1.214,1.274l-1.034,4.35a.729.729,0,0,1-.734.514Z",
    transform: "translate(-51.443 -184.958)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_612",
    "data-name": "Pfad 612",
    d: "M150.525,373.941h-14.4a1,1,0,0,1-1.064-1.209l.974-4.106a1.344,1.344,0,0,1,1.334-1h13.715a1.423,1.423,0,0,1,1.5,1.568L152,372.767a1.463,1.463,0,0,1-1.473,1.174Z",
    transform: "translate(-69.17 -184.801)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_613",
    "data-name": "Pfad 613",
    d: "M187.131,373.957H171.508a.714.714,0,0,1-.759-.759l.654-4.65a1.1,1.1,0,0,1,1.139-.889H187.48a1,1,0,0,1,1.049,1.044l-.6,4.625A.774.774,0,0,1,187.131,373.957Z",
    transform: "translate(-87.046 -184.817)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_614",
    "data-name": "Pfad 614",
    d: "M222.667,373.956H207.139a.729.729,0,0,1-.769-.744l.41-4.315a1.453,1.453,0,0,1,1.5-1.239h13.605a1.633,1.633,0,0,1,1.723,1.583l-.12,4a.769.769,0,0,1-.819.719Z",
    transform: "translate(-104.877 -184.815)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_615",
    "data-name": "Pfad 615",
    d: "M258.222,373.957H242.5a.5.5,0,0,1-.5-.469l.22-4.97a.954.954,0,0,1,1-.859h14.265a1.5,1.5,0,0,1,1.563,1.409v4.175a.759.759,0,0,1-.824.714Z",
    transform: "translate(-122.711 -184.816)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_616",
    "data-name": "Pfad 616",
    d: "M274.934,366.08h15.583a.629.629,0,0,1,.629.629v5.324a.35.35,0,0,1-.35.35H274.739a.569.569,0,0,1-.569-.569v-4.96a.764.764,0,0,1,.764-.774Z",
    transform: "translate(-137.23 -183.238)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_617",
    "data-name": "Pfad 617",
    d: "M310.08,366.08h16.252a.579.579,0,0,1,.579.579v5.324a.559.559,0,0,1-.559.559H310.139a.44.44,0,0,1-.44-.44V366.46A.38.38,0,0,1,310.08,366.08Z",
    transform: "translate(-155.015 -183.238)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_618",
    "data-name": "Pfad 618",
    d: "M396.7,349.917H382.157c-.43,0-.789-.2-.824-.469l-.295-2.278c-.03-.215.25-.4.6-.4h14.17c.469,0,.869.215.924.5l.654,2.163C397.44,349.692,397.115,349.917,396.7,349.917Z",
    transform: "translate(-192.304 -174.362)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_619",
    "data-name": "Pfad 619",
    d: "M362.141,349.917H347.9c-.42,0-.774-.2-.8-.469l-.29-2.278c-.03-.215.245-.4.589-.4h14.14c.465,0,.859.215.909.5l.4,2.163C362.885,349.692,362.551,349.917,362.141,349.917Z",
    transform: "translate(-175.171 -174.362)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_620",
    "data-name": "Pfad 620",
    d: "M430.341,350.242H416.59c-.744,0-1.383-.26-1.5-.614l-.764-2.073c-.085-.23.29-.445.779-.445h14.1c.5,0,.959.17,1.069.415l1,2.168C431.414,349.967,430.96,350.242,430.341,350.242Z",
    transform: "translate(-208.963 -174.532)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_621",
    "data-name": "Pfad 621",
    d: "M464.815,349.9h-14.1a1.464,1.464,0,0,1-1.279-.5l-1.079-2.273c-.095-.2.22-.385.639-.385h14.185a1.5,1.5,0,0,1,1.264.465l1.194,2.173C465.774,349.647,465.37,349.9,464.815,349.9Z",
    transform: "translate(-225.991 -174.342)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_622",
    "data-name": "Pfad 622",
    d: "M498.831,349.907H485.265c-.734,0-1.364-.26-1.5-.614l-.739-2.088c-.085-.235.285-.445.769-.445h13.915a1.189,1.189,0,0,1,1.054.41l1,2.173C499.895,349.633,499.44,349.907,498.831,349.907Z",
    transform: "translate(-243.35 -174.352)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_623",
    "data-name": "Pfad 623",
    d: "M532.991,349.783l-13.4.115a1.413,1.413,0,0,1-1.249-.5l-1.054-2.273c-.095-.2.215-.385.624-.385h13.61a1.448,1.448,0,0,1,1.234.465l1.034,2.058C533.93,349.533,533.535,349.783,532.991,349.783Z",
    transform: "translate(-260.498 -174.343)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_624",
    "data-name": "Pfad 624",
    d: "M121.446,349.757H107.461c-.579,0-1-.245-.889-.5l.959-2c.14-.295.709-.5,1.364-.5h13.061c.719,0,1.259.3,1.114.619l-.949,2.123C122.056,349.652,121.761,349.757,121.446,349.757Z",
    transform: "translate(-54.916 -174.357)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_625",
    "data-name": "Pfad 625",
    d: "M155.124,349.817H141.5c-.654,0-1.144-.285-1-.589l.919-2a1.454,1.454,0,0,1,1.264-.5h12.986c.864,0,1.528.36,1.4.764l-.5,1.728A1.6,1.6,0,0,1,155.124,349.817Z",
    transform: "translate(-71.896 -174.342)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_626",
    "data-name": "Pfad 626",
    d: "M190.278,349.837H175.654c-.43,0-.759-.175-.709-.37l.609-2.268c.07-.245.524-.43,1.069-.43h13.985c.589,0,1.049.235,1,.5l-.564,2.258C190.983,349.707,190.663,349.837,190.278,349.837Z",
    transform: "translate(-89.145 -174.362)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_627",
    "data-name": "Pfad 627",
    d: "M224.706,349.837H209.992c-.425,0-.759-.165-.724-.36l.39-2.108c.06-.34.679-.6,1.423-.6h12.876c.919,0,1.658.35,1.633.769l-.115,1.953C225.465,349.687,225.115,349.837,224.706,349.837Z",
    transform: "translate(-106.326 -174.362)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_628",
    "data-name": "Pfad 628",
    d: "M259.211,349.837H244.357c-.265,0-.5-.1-.469-.23l.2-2.417c0-.235.435-.42.939-.42h13.455c.814,0,1.473.3,1.473.684v2.038C259.96,349.682,259.625,349.837,259.211,349.837Z",
    transform: "translate(-123.655 -174.362)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_629",
    "data-name": "Pfad 629",
    d: "M275.754,345.18h14.679a.629.629,0,0,1,.629.629V347.9a.35.35,0,0,1-.35.35H275.559a.569.569,0,0,1-.569-.569v-1.733A.764.764,0,0,1,275.754,345.18Z",
    transform: "translate(-137.641 -172.777)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_630",
    "data-name": "Pfad 630",
    d: "M309.55,345.1h15.134a.579.579,0,0,1,.579.579v2a.559.559,0,0,1-.559.559H309.609a.44.44,0,0,1-.439-.44v-2.322a.38.38,0,0,1,.38-.375Z",
    transform: "translate(-154.749 -172.737)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_631",
    "data-name": "Pfad 631",
    d: "M380.307,360.243H365.652a.9.9,0,0,1-.829-.9l-.3-4.385a.684.684,0,0,1,.609-.774h14.28a1,1,0,0,1,.934,1l.659,4.16a.794.794,0,0,1-.7.9Z",
    transform: "translate(-184.036 -178.071)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_632",
    "data-name": "Pfad 632",
    d: "M345.667,360.243H331.152a.9.9,0,0,1-.824-.9l-.295-4.385a.684.684,0,0,1,.6-.774h14.389a1,1,0,0,1,.924,1l.4,4.16a.784.784,0,0,1-.689.9Z",
    transform: "translate(-166.773 -178.071)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_633",
    "data-name": "Pfad 633",
    d: "M414.435,360.243h-13.7a1.5,1.5,0,0,1-1.5-1.179l-.749-4.026a.754.754,0,0,1,.779-.859h14.065a1.084,1.084,0,0,1,1.069.794l1,4.18a.914.914,0,0,1-.969,1.089Z",
    transform: "translate(-201.039 -178.07)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_634",
    "data-name": "Pfad 634",
    d: "M449.681,360.243h-13.94a1.279,1.279,0,0,1-1.264-.939l-1.069-4.385a.619.619,0,0,1,.634-.739h14.02a1.284,1.284,0,0,1,1.249.9l1.179,4.185a.794.794,0,0,1-.809.979Z",
    transform: "translate(-218.513 -178.07)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_635",
    "data-name": "Pfad 635",
    d: "M483.98,360.243h-13.45a1.5,1.5,0,0,1-1.5-1.179l-.739-4.026a.749.749,0,0,1,.764-.859h13.82a1.059,1.059,0,0,1,1.044.794l1,4.18a.909.909,0,0,1-.939,1.089Z",
    transform: "translate(-235.976 -178.07)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_636",
    "data-name": "Pfad 636",
    d: "M527.6,360.243H506.127a2.039,2.039,0,0,1-1.948-.939l-1.643-4.385c-.14-.38.335-.739,1-.739h21.816a2.075,2.075,0,0,1,1.923.9l1.588,4.185C529.067,359.759,528.452,360.243,527.6,360.243Z",
    transform: "translate(-253.108 -178.071)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_637",
    "data-name": "Pfad 637",
    d: "M101.278,360.537H86.689a.844.844,0,0,1-.919-.969l1-3.836a1.418,1.418,0,0,1,1.418-.959h13.625a1.054,1.054,0,0,1,1.159,1.194l-1,4.086a.7.7,0,0,1-.694.484Z",
    transform: "translate(-44.507 -178.365)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_638",
    "data-name": "Pfad 638",
    d: "M135.6,360.39H121.65a1,1,0,0,1-1.029-1.134l.944-3.856a1.294,1.294,0,0,1,1.294-.924h13.276a1.354,1.354,0,0,1,1.443,1.473l-.544,3.336A1.409,1.409,0,0,1,135.6,360.39Z",
    transform: "translate(-61.951 -178.217)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_639",
    "data-name": "Pfad 639",
    d: "M171.187,360.391H156.433a.669.669,0,0,1-.714-.714l.614-4.365a1.049,1.049,0,0,1,1.074-.834h14.11a.929.929,0,0,1,1,1l-.569,4.345a.734.734,0,0,1-.759.569Z",
    transform: "translate(-79.523 -178.218)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_640",
    "data-name": "Pfad 640",
    d: "M206.383,360.391H191.654a.684.684,0,0,1-.724-.7l.385-4.056a1.378,1.378,0,0,1,1.428-1.159h12.886a1.543,1.543,0,0,1,1.633,1.5l-.115,3.756A.729.729,0,0,1,206.383,360.391Z",
    transform: "translate(-97.149 -178.218)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641",
    "data-name": "Pfad 641",
    d: "M241.448,360.391H226.429a.455.455,0,0,1-.5-.44l.21-4.67a.9.9,0,0,1,.949-.8h13.6a1.413,1.413,0,0,1,1.5,1.324v3.931A.714.714,0,0,1,241.448,360.391Z",
    transform: "translate(-114.668 -178.218)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_642",
    "data-name": "Pfad 642",
    d: "M258.544,352.9h14.669a.629.629,0,0,1,.629.629v4.915a.35.35,0,0,1-.35.35H258.349a.569.569,0,0,1-.569-.569v-4.575A.764.764,0,0,1,258.544,352.9Z",
    transform: "translate(-129.027 -176.641)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_643",
    "data-name": "Pfad 643",
    d: "M292.85,352.6h14.819a.579.579,0,0,1,.579.579V358.1a.559.559,0,0,1-.559.559H292.91a.44.44,0,0,1-.44-.44V352.98A.38.38,0,0,1,292.85,352.6Z",
    transform: "translate(-146.39 -176.491)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_644",
    "data-name": "Pfad 644",
    d: "M527.633,402.682H489.479a1.668,1.668,0,0,1-1.608-1.239l-1.1-4.136a1.414,1.414,0,0,1,1.369-1.778h36.331a2.073,2.073,0,0,1,2,1.468l1.578,5.134a.425.425,0,0,1-.415.549Z",
    transform: "translate(-245.206 -198.768)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_645",
    "data-name": "Pfad 645",
    d: "M532.663,388.193H503.3a1.344,1.344,0,0,1-1.234-1.144l-.839-3.841a1.276,1.276,0,0,1,1.044-1.648h27.795a1.653,1.653,0,0,1,1.523,1.363l1.373,4.76a.384.384,0,0,1-.295.509Z",
    transform: "translate(-252.444 -191.776)",
    fill: "#121418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_646",
    "data-name": "Pfad 646",
    d: "M298.553,1.58H60.916a4,4,0,0,0-4,4V167.55a1.748,1.748,0,0,0,1.748,1.748H300.8a1.743,1.743,0,0,0,1.748-1.748V5.576A4,4,0,0,0,298.553,1.58Zm-5.229,154.043H65.87V13.747H293.324Z",
    transform: "translate(-30.071 -1.58)",
    fill: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_647",
    "data-name": "Pfad 647",
    d: "M298.53,3.31H62.076A3.746,3.746,0,0,0,58.33,7.056v161.71a1.4,1.4,0,0,0,1.4,1.4H300.9a1.4,1.4,0,0,0,1.4-1.4V7.056A3.746,3.746,0,0,0,298.53,3.31Zm-4.5,153.189H66.576V14.613H294.03Z",
    transform: "translate(-30.777 -2.446)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopWrapper);
export default __webpack_public_path__ + "static/media/laptop_wrapper.7216b1dfaf9f0c8ef796ffa3398e3f2b.svg";
export { ForwardRef as ReactComponent };